<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add v-if="hasPerm('projects.create')" @invoke-method="invokeMethod($event)" action="openProjectForm"></bc-btn-add>
                            <bc-btn-refresh @invoke-method="dbGetProjects(true)"></bc-btn-refresh>
                            <bc-search-menu :params="axiosParams">
                                <v-list>
                                    <v-list-tile>
                                        <bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-switch
                                                v-model="filter.status"
                                                color="success"
                                                :label="filter.status == '1' ? $t('lang.active') : $t('lang.inactive')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </v-list>
                            </bc-search-menu>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : null">
                    <v-data-table :headers="headers" :items="projects" :no-data-text="$t('lang.no_results_matching')" hide-actions>
                        <template slot="items" slot-scope="props">
                            <tr class="clickable" @mouseup.left="openProjectForm(props.item)">
                                <td>{{ props.item.project_id }}</td>
                                <td>{{ props.item.company }}</td>
                                <td>{{ props.item.project_name }}</td>
                                <td>{{ props.item.serial_number }}</td>
                                <td>{{ props.item.model }}</td>
                                <td>{{ props.item.manufacture_date }}</td>
                                <td>{{ props.item.start_date }}</td>
                                <td>{{ props.item.end_date }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <bc-pagination :page="page" :params="axiosParams" name="projects"></bc-pagination>
                </v-card-text>
            </v-card>

            <bc-dialog :value="project_dialog" max-width="800">
                <v-card>
                    <v-form ref="form_project">
                        <v-card-title>
                            <span class="headline">{{ project.project_id ? $t("lang.edit_project") : $t("lang.add_project") }}</span>
                            <v-spacer></v-spacer>
                            <bc-btn-dialog-close
                                @invoke-method="invokeMethod($event)"
                                action="closeProjectDialog"
                                :dialog-status="project_dialog"
                            ></bc-btn-dialog-close>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-form>
                                <v-layout row wrap>
                                    <!-- <v-flex xs12>
                                        <v-text-field
                                            v-focus="project_dialog"
                                            v-model="project.project_id"
                                            :label="`${$t('lang.project_id')} *`"
                                            :counter="showCounter(project.project_id, 'projects.project_id')"
                                            :rules="ifValid('projects.project_id')"
                                        ></v-text-field>
                                    </v-flex> -->
                                    <v-flex xs6>
                                        <bc-autocomplete
                                            v-model="project.company_id"
                                            :label="$t('lang.company_id')"
                                            :items="companies || []"
                                            item-value="company_id"
                                            item-text="company"
                                            :rules="ifValid('projects.company_id')"
                                        ></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="project.project_name"
                                            :label="`${$t('lang.project_name')} *`"
                                            :counter="showCounter(project.project_name, 'projects.project_name')"
                                            :rules="ifValid('projects.project_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="project.serial_number"
                                            :label="$t('lang.serial_number')"
                                            :counter="showCounter(project.serial_number, 'projects.serial_number')"
                                            :rules="ifValid('projects.serial_number')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="project.model"
                                            :label="$t('lang.model')"
                                            :counter="showCounter(project.model, 'projects.model')"
                                            :rules="ifValid('projects.model')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="project.contact_name"
                                            :label="$t('lang.contact_name')"
                                            :counter="showCounter(project.contact_name, 'projects.contact_name')"
                                            :rules="ifValid('projects.contact_name')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <bc-date-picker
                                            v-model="project.manufacture_date"
                                            :label="$t('lang.manufacture_date')"
                                            :rules="ifValid('projects.manufacture_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="project.contact_email"
                                            :label="$t('lang.contact_email')"
                                            :counter="showCounter(project.contact_email, 'projects.contact_email')"
                                            :rules="ifValid('projects.contact_email')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="project.contact_phone"
                                            :label="$t('lang.contact_phone')"
                                            type="phone"
                                            mask="(###) ### - ####"
                                            :rules="ifValid('projects.contact_phone')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <bc-date-picker
                                            v-model="project.start_date"
                                            :label="$t('lang.start_date')"
                                            :rules="ifValid('projects.start_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs6>
                                        <bc-date-picker
                                            v-model="project.end_date"
                                            :label="$t('lang.end_date')"
                                            :rules="ifValid('projects.end_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs6>
                                        <bc-date-picker
                                            v-model="project.po_issue_date"
                                            :label="$t('lang.po_issue_date')"
                                            :rules="ifValid('projects.po_issue_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs6>
                                        <bc-date-picker
                                            v-model="project.po_received_date"
                                            :label="$t('lang.po_received_date')"
                                            :rules="ifValid('projects.po_received_date')"
                                        ></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-text-field
                                            v-model="project.customer_po"
                                            :label="$t('lang.customer_po')"
                                            :counter="showCounter(project.customer_po, 'projects.customer_po')"
                                            :rules="ifValid('projects.customer_po')"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-textarea
                                            v-model="project.notes"
                                            :label="$t('lang.notes')"
                                            auto-grow
                                            rows="1"
                                            :rules="ifValid('projects.notes')"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn v-if="project.project_id" color="error" @mouseup.left="$refs.delete_projects.openDialog()">{{ $t("lang.delete") }}</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn flat @mouseup.left="closeProjectDialog()">{{ $t("lang.cancel") }}</v-btn>
                            <v-btn color="success" @click="saveProjects">{{ $t("lang.save") }}</v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="delete_projects"
                :heading="$t('lang.delete_project')"
                :message="$t('lang.confirm_delete_message')"
                @onConfirm="deleteProjects(project.project_id)"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "openProjectForm" },
                { title: this.$t("lang.refresh"), action: "dbGetProjects", params: [true] },
            ],
            headers: [
                { text: this.$t("lang.project"), sortable: false, width: "6%" },
                { text: this.$t("lang.company_id"), sortable: false, width: "15%" },
                { text: this.$t("lang.project_name"), sortable: false, width: "10%" },
                { text: this.$t("lang.serial_number"), sortable: false, width: "6%" },
                { text: this.$t("lang.model"), sortable: false, width: "6%" },
                { text: this.$t("lang.manufacture_date"), sortable: false, width: "6%" },
                { text: this.$t("lang.start_date"), sortable: false, width: "6%" },
                { text: this.$t("lang.end_date"), sortable: false, width: "6%" },
            ],
            enableAddModal: true,
            enableEditModal: false,
            customers: null,
            project: {},
            filter: {
                search: "",
                status: "1",
                company_id: "",
            },
            project_dialog: false,
            dbGetProjects: _.debounce(this.getProjects, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        store
            .dispatch("fetchProjects", {
                body: parsedQuery,
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.projects) {
                    next((vm) => {
                        vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
                        vm.refresh();
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        let parsedQuery = JSON.parse(JSON.stringify(to.query));
        this.fetchProjects({
            body: parsedQuery,
        }).then((data) => {
            if (typeof data !== "undefined" && data.projects) {
                this.setQuery(parsedQuery, this.filter, this.default_filter);
                this.finishLoader();
                this.refresh();
                next();
            } else {
                next({ name: "dashboard", replace: true });
            }
        });
    },
    computed: {
        ...mapState({
            default_filter: (state) => state.projects.projects_filter,
            page: (state) => state.projects.page,
            rules_projects: (state) => state.projects.rules_projects,
            project_status_options: (state) => state.settings.project_status_options,
            projects: (state) => state.projects.projects,
            companies: (state) => state.companies.company_options,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
    },
    methods: {
        ...mapActions(["fetchProjects", "saveProject", "deleteProject", "fetchCompanies"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        openProjectForm(item = null) {
            if (item != null) {
                if (this.enableEditModal) {
                    if (this.$refs.form_project) item ? this.$refs.form_project.resetValidation() : this.$refs.form_project.reset();

                    this.$nextTick(() => {
                        this.project = item != null ? this.assignObj2(item, this.rules_projects) : {};
                        this.project_dialog = true;
                    });
                } else {
                    this.$router.push({ name: "project", params: { id: item.project_id } });
                }
            } else {
                if (this.enableAddModal) {
                    if (this.$refs.form_project) item ? this.$refs.form_project.resetValidation() : this.$refs.form_project.reset();
                    this.project_dialog = true;
                } else {
                    this.$router.push({ name: "project" });
                }
            }
        },
        saveProjects() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_project")) {
                    let body = this.prepForm(this.project, this.rules_projects);

                    this.saveProject({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getProjects();
                                this.closeProjectDialog();
                            } else {
                                this.$router.push({ name: "project", params: { id: data.projects.project_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        deleteProjects(id = null) {
            this.deleteProject({
                id: id,
            }).then((data) => {
                if (data && data.code == "200") {
                    this.getProjects();
                    this.closeProjectDialog();
                } else {
                    this.toggleModalLoader(false);
                }
            });
        },

        closeProjectDialog() {
            this.project_dialog = false;
            this.$refs.delete_projects.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        getProjects(pg_refresh = false) {
            this.startLoader();

            this.fetchProjects({
                body: JSON.parse(JSON.stringify(this.$route.query)),
            })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.project_dialog = false;
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "me/companies?module=people",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.companies;
                    }
                });
        },
        async refresh(force = false) {
            if (force == true) {
                await this.fetchProjects({
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                });
            }

            if (this.companies.length == 0 || force == true) await this.fetchCompanies({ body: { options: 1 } });
        },
    },
};
</script>
